<template>
	<div>
		<div class="head">
			<div>
				<img src="../assets/img/logo.png" @click="goTo('/index')"/>
			</div>
			<div class="head-wrapper">
				<div v-for="(o,i) in tabStr">
					<span @click="changeTab(i,o.path)">{{o.title}}</span>
				</div>
			</div>
			<!-- <div class="open-icon" @click="openDrawer">
				<img src="../assets/img/icon/zhankai.png"/>
			</div>  :class="isOpen?'openDraw':'closeDraw'"-->
			<div class="head-draw">
				<div class="t-align-center dp-f">
					<div v-for="(o,i) in tabStr">
						<div v-for="(item,index) in o.children" class="nav-child">
							<span @click="goTo(item.path)">{{item.title}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				tabStr:[{
					title:'首页',
					path:'/index',
					children:[]
				},{
					title:'服务内容',
					path:'/service',
					children:[
						{
							title:'等保测评',
							path:'/equal'
						},
						{
							title:'密评咨询',
							path:'/confidential'
						},
						{
							title:'软件检测',
							path:'/software'
						},
						{
							title:'漏洞扫描',
							path:'/vulnerability'
						},
						{
							title:'风险评估',
							path:'/risk'
						},
						{
							title:'安全培训',
							path:'/safety'
						},
						{
							title:'应急响应',
							path:'/emergency'
						},
						{
							title:'渗透测试',
							path:'/penetration'
						},
						{
							title:'机房检测',
							path:'/computer'
						},
						{
							title:'代码审计',
							path:'/code'
						},
					]
				},{
					title:'关于我们',
					path:'/about',
					children:[
						{
							title:'公司简介',
							path:'/about'
						},
						// {
						// 	title:'荣誉与资质',
						// 	path:'/honor'
						// },
					]
				}],
				tabIndex:0,
				isOpen:false
			}
		},
		methods:{
			changeTab(index,path){
				this.tabIndex = index
				this.$router.push({
					path:path
				})
			},
			openDrawer(){
				this.isOpen = !this.isOpen
			},
			goTo(path){
				this.$router.push({
					path:path
				})
			}
		}
	}
</script>

<style>
.head{
	width: 100%;
	height: 80px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	background-color: #fff;
	z-index: 999;
}
.head>div:first-child{
	width: 280px;
	height: auto;
	margin-left: 240px;
}
.head>div:first-child img{
	width:100%;
	height: 100%;
}
.head-wrapper{
	display: flex;
	height: 80px;
	width: 540px;
	font-size: 18px;
	font-weight: bold;
	line-height: 80px;
}
.head-wrapper>div{
	width: 180px;
	text-align: center;
	color: #333333;
}
.head-wrapper>div span:hover{
	color: #006AFF;
	cursor: pointer;
}
.open-icon{
	width: 80px;
	height: 80px;
	margin-left: auto;
	background: linear-gradient(115deg,#4264b5,#368493);
	display: flex;
	justify-content: center;
	align-items: center;
}
.open-icon>img{
	width: 36px;
	height: 36px;
}
.head-draw{
	width: 100%;
	background-color: #fff;
	position: fixed;
	top: 80px;
	left: 0;
	z-index: 99;
	box-shadow: 0px 7px 8px 0px #e5e5e5;
	overflow: hidden;
	height: 0;
	transition: height 0.5s linear 0s;
}
.head-draw>div{
	margin-left: 700px;
}
.nav-child{
	width: 180px;
	line-height: 40px;
}
.nav-child span{
	cursor: pointer;
}
.head-draw .nav-child span:hover{
	color: #4264b5;
}
.head:hover .head-draw{
	height: 420px;
	transition: height 0.5s linear 0s;
	z-index: 100;
}
/* .openDraw{
	height: 420px;
	transition: height 0.5s linear 0s;
	z-index: 100;
} */
/* .closeDraw{
	height: 0;
	transition: height 0.5s linear 0s;
} */
/* 适配 */
@media screen and (max-width: 1029px) {
	
}
@media screen and (max-width: 1024px) {
	
}
</style>